import { HStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../components/TableContent';

export const SecondCopyListLoadingMobile: React.FC = () => {
  return (
    <TableContent
      direction="column"
      space={Spacing['stack.xxxs']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
      <HStack width="100%" space={Spacing['stack.quarck']}>
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
        <Skeleton
          width="100%"
          height={Spacing['inline.xxs']}
          borderRadius={BoxRadius.sm}
          flex={1}
        />
      </HStack>
    </TableContent>
  );
};
